import React from 'react';
import { layouts, textblocks } from 'seal-ui-components';
import { ClauseTextWrapper } from './ClauseDetailsCard.style';
import { Card } from '@Components/UI/Card';
import useWindowSize from '@Hooks/useWindowSize';
import Selectable from '@Components/Selectable';
import { decodeHtmlText } from '@Utils/commonUtils';
import { LongTrimmedTitle } from '@Components/LongTitle';

const ICONS_CONTAINER_WIDTH = 70;
const FRACTION_WIDTH_TITLE_SUBTITLE = 4 / 5;

export function ClauseDetailsCard({
    title,
    subTitle,
    text,
    description,
    clauseId,
    clausesCount,
    clausePriority
}) {
    const size = useWindowSize();
    const MAX_WIDTH_TITLE_SUBTITLE =
        size.width * FRACTION_WIDTH_TITLE_SUBTITLE - ICONS_CONTAINER_WIDTH;

    return (
        <Card color={'rgb(238, 238, 238)'}>
            <layouts.VerticalBox gap={0}>
                <layouts.HorizontalBox align="center" style={{ justifyContent: 'space-between' }}>
                    <layouts.VerticalBox gap={0}>
                        <LongTrimmedTitle title={title} />

                        <textblocks.Heading4
                            style={{
                                maxWidth: isNaN(MAX_WIDTH_TITLE_SUBTITLE)
                                    ? '100%'
                                    : MAX_WIDTH_TITLE_SUBTITLE
                            }}
                        >
                            {subTitle}
                        </textblocks.Heading4>
                    </layouts.VerticalBox>
                </layouts.HorizontalBox>
                {description && (
                    <ClauseTextWrapper>
                        <Selectable
                            className="selectable"
                            lines={25}
                            originalText={decodeHtmlText(description)}
                            moreText="Show more"
                            lessText="Show less"
                        />
                        <layouts.VerticalBoxDivider className="divider" />
                    </ClauseTextWrapper>
                )}
                <ClauseTextWrapper>
                    <Selectable
                        className="selectable"
                        originalText={decodeHtmlText(text)}
                        lines={10}
                        withInsert
                        moreText="Show more"
                        lessText="Show less"
                        clausesCount={clausesCount}
                        clauseId={clauseId}
                        clausePriority={clausePriority}
                    />
                </ClauseTextWrapper>
            </layouts.VerticalBox>
        </Card>
    );
}
